import Cookies from 'js-cookie';
import { refreshToken } from '@utils/auth';

export async function fetchWithToken(url: string, options: RequestInit = {}, retries = 1): Promise<Response> {
  const response = await fetch(`${url}`, {
    ...options,
    headers: {
      ...options.headers,
      Authorization: `Bearer ${Cookies.get('access_token')}`,
    },
  });

  if (response.status === 401 && retries > 0) {
    const refreshTokenString = Cookies.get('refresh_token');

    if (typeof refreshTokenString !== 'string') {
      throw new Error('No refresh token found');
    }

    try {
      const response = await refreshToken({ refreshToken: refreshTokenString });

      if (!response.accessToken) {
        throw new Error('No access token found');
      }

      Cookies.set('access_token', response.accessToken);

      return fetchWithToken(url, options, retries - 1);
    } catch (error) {
      console.error('Error refreshing token:', error);
      throw new Error('Error refreshing token');
    }
  }

  if (!response.ok) {
    throw new Error('Error fetching data');
  }

  return response;
}